module.exports = __webpack_public_path__ + "img/ceping.220378b9.png";